module.exports = __webpack_public_path__ + "img/hr-rock-huge-08.2d080f0e.png";